export const COMPETITIVE = 'competitive';
export const HIGH = 'high';
export const FAIR = 'fair';

export const CHART_LABELS = {
  COMPETITIVE: 'Competitive',
  HIGH: 'High',
  AVERAGE: 'Average',
};

export const BARS_NUMBER = 8;
